import React, { useRef, useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

import CssBaseline from '@mui/material/CssBaseline';
import { alpha, Button, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';


import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { ThemeProvider } from '@mui/material/styles';
import { Autoplay, Pagination } from 'swiper/modules';

import { GlobalTheme } from '../../theme';
const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + '...';
  }
  return text;
};

const DynamicMantle = ({ banner_type, banner_src, banner_alt, banner_title, banner_description, isLoading, openOfferDialog }) => {
  const [animate, setAnimate] = useState(false);

  // if (isLoading) {
  //   // Render a different block when isloading is true
  //   return (
  //     <>
  //     <Box position='absolute' width='100%' height='100%' sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginBottom: 4 }}>
  //         <Skeleton variant="rectangular" animation='wave' width={200} sx={{ height: 20, mb: 3 }} />
  //         <Skeleton variant="rectangular" animation='wave' width={500} sx={{ height: 10, mb: 1 }} />
  //         <Skeleton variant="rectangular" animation='wave' width={400} sx={{ height: 10, mb: 1 }} />
  //         <Skeleton variant="rectangular" animation='wave' width={200} sx={{ height: 10, mb: 1 }} />

  //         <Skeleton variant="rectangular" animation='wave' width={600} sx={{ height: 65, mt: 5, mb: 1, borderRadius: 2 }} />
  //     </Box>

  //     <Skeleton variant="rectangular" animation='wave' width='100%' height={833} sx={{ height: 20, mb: 3 }} />

  // </>
  //   );
  // }

  useEffect(() => {
    // Trigger animation once the component mounts
    const timeout = setTimeout(() => {
      setAnimate(true);
    }, 0); // Delay can be adjusted as needed
    return () => clearTimeout(timeout); // Cleanup
  }, []);

  return (

    <React.Fragment>
      <ThemeProvider theme={GlobalTheme}>
        <CssBaseline />
        <Card id="headerContainer"
          sx={{
            borderRadius: 0,
            position: 'relative',
            zIndex: 1,
            height: { xs: 300, md: 'auto' },
          }}>
          <Swiper
            direction={'vertical'}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination, Autoplay]}
            // className="mySwiper"
            className={animate ? 'animate__animated animate__fadeIn' : ''}
          >
            <SwiperSlide>
              {banner_type === 'video' ? (
                <CardMedia
                  key={banner_src}
                  id="mantleMedia"
                  component="video"
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: true,
                  }}
                  loop
                  muted
                  playsInline
                  sx={{
                    height: { xs: 300, md: 500 }, // Ensures video height adapts with container
                    objectFit: 'cover',
                  }}
                >
                  <source src={banner_src} type="video/mp4" />
                  <Typography variant='subtitle2' component='p'> Your browser does not support the video tag.</Typography>
                </CardMedia>
              ) : (
                <CardMedia
                  id="mantleMedia"
                  component="img"
                  image={banner_src}
                  alt={banner_alt}
                  loading='lazy'
                  sx={{
                    height: { xs: 300, md: 500 },
                    objectFit: 'cover',
                  }}
                />
              )
              }
            </SwiperSlide>
          </Swiper>

          <Box
            sx={{
              position: { xs: 'absolute' },
              height: '100%',
              width: '100%',
              textAlign: 'center',
              left: 0,
              bottom: 0,
              top: 0,
              backgroundColor: {
                // xs: GlobalTheme.palette.common.black,
                xs: alpha(GlobalTheme.palette.common.black, .65)
              },
              zIndex: 2,
            }}>
            <CardContent id="mantleText"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                flexDirection: 'column',
                flexWrap: 'wrap',
                alignContent: 'center',
                pl: {
                  xs: 3,
                  md: 6
                },
                pr: {
                  xs: 3,
                  md: 8
                },
                pt: {
                  xs: 3,
                  md: 10
                }
              }}>
              <Stack>
                <Typography id="mantleHeading" gutterBottom variant='h1' color='white' className={animate ? 'animate__animated animate__fadeInUp animate__delay-1s' : ''}
                  sx={{
                    fontSize: '2rem'
                  }}>{banner_title}</Typography>
                <Typography id="mantleSubHeading" component='p' variant="subtitle1" color='white' gutterBottom className={animate ? 'animate__animated animate__fadeInUp animate__delay-1s' : ''}
                  sx={{
                    px: { sm: 5, lg: 20 }
                  }}>
                  {truncateText(banner_description, 200)}

                </Typography>
                <Box mt={2} className={animate ? 'animate__animated animate__fadeInUp animate__delay-1s' : ''}>
                  <Button id='btnSendEnquiry' variant="contained" color="primary" onClick={openOfferDialog} sx={{ color: GlobalTheme.palette.common.white }} >Send Enquiry</Button>
                </Box>

              </Stack>
            </CardContent>
          </Box>

          <Box
            sx={{
              background: 'linear-gradient(0deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.1) 100%)',
            }}
            width='100%'
            height='100%'
            position='absolute'>
          </Box>
        </Card>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default DynamicMantle;